import * as Yup from 'yup';
import ErrorMessages from '../errorConfig.js';

export const LoginSchema = Yup.object().shape({
    username: Yup.string().required(ErrorMessages.USERNAME_REQUIRED),
    password: Yup.string()
        .required(ErrorMessages.PASSWORD_REQUIRED),
});
